<section class="flex-container login">
  <div class="col-50 cover cover-admin"></div>
  <div class="col-50 center content">
    <div class="center login-form">
      <a routerLink="/">
        <!-- <img src="assets/img/logo.webp" alt="Deluxy" class="logo"> -->
        <img src="assets/img/deluxy_nuovo_logo_1_140x.webp" alt="Deluxy" class="logo">
      </a>
      <br><br>
      <!-- <span class="riga"></span> -->
      <div *ngIf="this.validToken; then newPasswordForm; else recoverForm"></div>
    </div>
  </div>
</section>

<ng-template #recoverForm>
  <h3>Recupero password</h3>
  <form id="recoverForm" #recoverForm="ngForm" (ngSubmit)="recovery()">
    <input type="email" [(ngModel)]="loginDTO.email" name="email" placeholder="La tua email" required>

    <button class="btn hvr-shrink" type="submit">Recupera password<i class="ml-10 fas fa-arrow-right"></i></button>
  </form>
</ng-template>

<ng-template #newPasswordForm>
  <h3 *ngIf="!activate">Reimposta password</h3>
  <h3 *ngIf="activate">Imposta la tua password</h3>
  <app-new-password-form [token]="token" [activate]="activate"></app-new-password-form>
  <button class="btn hvr-shrink" (click)="setNewPassword()">Imposta password<i class="ml-10 fas fa-arrow-right"></i></button>
</ng-template>
